import {DESKTOP_CONTENT_SIDE_PADDING} from '@constant/system';

const desktop = theme => {
  const {toVW} = theme;
  return {
    layout: {
      minHeight: '100vh',
      height: '100%',
    },
    antLayout: {
      '&.desktop-padding': {
        padding: [0, DESKTOP_CONTENT_SIDE_PADDING],
      },
      backgroundColor: theme.desktopContentBackground,
      // * black space will be appear if overflowY is removed
      // * if this is put in mobile => PLO in game list will be scrolled to btm
      overflowY: 'auto',
    },
    content: {
      backgroundColor: theme.desktopContentBackground,
      width: '100%',
      height: '100%',
    },
  };
};

const mobile = theme => {
  return {
    '@global': {
      body: {
        color: 'white',
        backgroundColor: theme.backgroundColor,
        paddingBottom: 24,
      },
    },
    antLayout: {
      backgroundColor: theme.backgroundColor,
      height: '100dvh',
    },
    antdTabs: {
      color: 'white',
      backgroundColor: theme.backgroundColor,
    },
    content: {
      // background: theme.contentBackground,
      backgroundColor: theme.backgroundColor,
      display: 'block',
      position: 'relative',
      width: '100%',
    },
    loadingScreen: {
      zIndex: 10,
      backgroundColor: 'rgba(255, 255, 255, 0.3)',
      width: '100vw',
      height: '100vh',
      position: 'absolute',
      top: 0,
      left: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    footer: {
      padding: 0,
    },
    modalTitle: {
      display: 'block',
      fontSize: '14px',
      textAlign: 'center',
      paddingTop: 15,
    },
    modalImageDiv: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: 10,
      minHeight: '87px',
    },
    modalContent: {
      extend: 'modalTitle',
      color: '#D5D5D5',
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
